import { createPortal } from 'preact/compat';
import type { ComponentChildren } from 'preact';

export type PortalLayer = 'modal' | 'drawer' | 'popover' | 'toast';

const LAYER_TO_ID: Record<PortalLayer, string> = {
  modal: 'portal-modal',
  drawer: 'portal-drawer',
  popover: 'portal-popover',
  toast: 'portal-toast',
};

export interface PortalProps {
  layer: PortalLayer;
  children: ComponentChildren;
}

export function Portal({ layer, children }: PortalProps) {
  if (typeof document === 'undefined') return null;
  const target = document.getElementById(LAYER_TO_ID[layer]);
  if (!target) return null;
  return createPortal(<>{children}</>, target);
}
